<template>
    <div style="font-size: 23.4375px;">
        <!--    导航栏-->
        <Anav pro="1"></Anav>
        <!--    标签栏-->
        <Atablebar></Atablebar>
<!--        <div class="content">-->
<!--            <div class="title-box">-->
<!--                <div class="title">-->
<!--                    <div>产品展示</div>-->
<!--                </div>-->
<!--            </div>-->

<!--        </div>-->
<!--        <div style="width: 100%;height: 3rem"></div>-->
        <van-pull-refresh v-model="isLoading" @refresh="onRefresh" style="height: 600px; overflow: auto; border-top: 1px solid #fff;">
            <van-list
                    v-model="isUpLoading"
                    :finished="upFinished"
                    @load="onLoads"
                    :offset="offset" :immediate-check="false"
            >
            <div class="content">
                <div class="title-box">
                    <div :class="[!color1?'text':'text colors']" role="button" aria-labelledby="mingcheng">
                        <div @click="proname" id="mingcheng" aria-hidden="true">名称<van-icon class="vanticon" :name="Iconname"/></div>
                    </div>
                    <div :class="[!color2?'text':'text colors']" role="button" aria-labelledby="shijian">
                        <div @click="protime" id="shijian" aria-hidden="true">时间<van-icon class="vanticon" :name="Icontime" /></div>
                    </div>
                    <div :class="[!color3?'text':'text colors']" role="button" aria-labelledby="jiage">
                        <div @click="proprice" id="jiage" aria-hidden="true">价格<van-icon class="vanticon" :name="Iconprice" /></div>
                    </div>
                </div>
                <!--                list-->
                <div class="list-box">
                    <div class="list-item" v-for="(item,index) in asblist" :key="index" @click="lookinfo(item)" role="button" :aria-labelledby="['listItem' + index]">
                        <div class="img-item"><img :src=item.image alt="产品图片"></div>
                        <div class="content-item" :id="['listItem' + index]" aria-hidden="true">
                            <div class="title-item">{{item.prodName}}</div>
                            <div class="text-item">{{item.prodDescribe}}</div>
                            <div class="money-item">￥{{item.price}}</div>
                        </div>
                    </div>
                </div>
                <div class="list-bottom"></div>
                <!--<div class="list-box" >
                    <div class="list-item2" >
                        <van-pagination v-model="currentPage" @change="turnto" :page-count="allPage" mode="simple" />
                    </div>
                </div>-->
            </div>
            </van-list>
        </van-pull-refresh>


    </div>
</template>

<script>
    //引入导航组件
    import Anav from './Acomponent/Anav';
    import Atablebar from './Acomponent/Atablebar';
    import vant, {Notify,PullRefresh,Toast,List} from 'vant'
    import Vue from 'vue';
    import { Pagination } from 'vant';
    import Cookies from "js-cookie";
    import { Icon } from 'vant';

    Vue.use(Icon);
    Vue.use(Pagination).use(PullRefresh).use(Toast).use(List);
    export default {
        components: {
            // eslint-disable-next-line vue/no-unused-components
            Anav,
            // eslint-disable-next-line vue/no-unused-components
            Atablebar,
        },
        name: "Aproduce",
        data(){
            return{
                currentPage: 1,
                asblist:[],
                Iconname:'arrow-down',
                Icontime:'',
                Iconprice:'',
                flag1:true,
                flag2:false,
                flag3:false,
                color1:true,
                color2:false,
                color3:false,
                page:1,
                count: 0,
                isLoading: false,
                isUpLoading:false,//上拉加载
                upFinished:false,//上拉加载完毕
                offset:100,//滚动条与底部距离小于 offset 时触发load事件
            }
        },
        mounted() {
            this.getAsbList(this.page,"desc","")
        },
        watch: {
            $route: {
                handler: function(val, oldVal){
                    this.getAsbList(this.page,"desc",val.query.proname)
                },
            }
        },
        methods:{
            getAsbList(n,str,text){
                if(text!=""){
                    this.$axios.get("/product/listAnShiBao?type=0&prodTag=1&prodName="+text+"&pageSize=4&sort="+str+"&page="+n).then(res=>{
                        this.asblist=res.data.rows
                        if(res.data.rows==0){
                            Notify({ type: 'danger', message: '没有匹配内容！'})
                        }

                    })
                }else{
                    this.$axios.get("/product/listAnShiBao?type=0&prodTag=1&prodName="+text+"&pageSize=4&sort="+str+"&page="+n).then(res=>{
                        this.asblist=res.data.rows

                    })
                }

            },
            onRefresh() {
                setTimeout(() => {
                    Toast('刷新成功');
                    this.isLoading = false;
                }, 1000);
            },
            onLoads () { // 上拉调用此函数
                setTimeout(() => {
                    this.isUpLoading = false;
                    this.$axios.get("/product/listAnShiBao?type=0&prodTag=1&prodName=&pageSize=4&sort=desc&page="+(++this.page)).then(res=>{
                        if(res.data.rows.length>0){
                            Toast('加载成功');//弹出
                            for(var i=0;i<res.data.rows.length;i++){
                                this.asblist.push(res.data.rows[i])
                            }
                            console.log(this.asblist)
                        }else {
                            Toast('没有更多数据了');//弹出

                            this.upFinished = true;
                        }

                    })
                }, 1000);
            },
            proname(){
                if(this.flag1){
                    this.flag1=false
                    this.Iconname='arrow-up';
                    this.Iconprice=''
                    this.Icontime=''
                    this.getAsbList(this.page,"asc","",'')
                }else{
                    this.flag1=true
                    this.Iconname='arrow-down';
                    this.Iconprice=''
                    this.Icontime=''
                    this.getAsbList(this.page,"desc","",'')
                }
                this.color1=true;
                this.color2=false;
                this.color3=false;

            },
            protime(){
                if(this.flag2){
                    this.flag2=false
                    this.Icontime='arrow-up';
                    this.Iconname='';
                    this.Iconprice=''
                    this.asblist=this.asblist.sort(function(a,b) {
                        return Date.parse(a.createTime.replace(/-/g,"/"))-Date.parse(b.createTime.replace(/-/g,"/"));
                    });
                }else{
                    this.flag2=true
                    this.Icontime='arrow-down';
                    this.Iconname='';
                    this.Iconprice=''
                    this.asblist=this.asblist.sort(function(a,b) {
                        return Date.parse(b.createTime.replace(/-/g,"/"))-Date.parse(a.createTime.replace(/-/g,"/"));
                    });
                }
                this.color2=true;
                this.color1=false;
                this.color3=false;

            },
            proprice(){
                if(this.flag3){
                    this.flag3=false
                    this.Iconname='';
                    this.Iconprice='arrow-up'
                    this.Icontime=''
                    this.asblist=this.asblist.sort(function(a,b) {
                        return a.price-b.price;
                    });
                }else{
                    this.flag3=true
                    this.Iconname='';
                    this.Iconprice='arrow-down'
                    this.Icontime=''
                    this.asblist=this.asblist.sort(function(a,b) {
                        return b.price-a.price;
                    });
                }
                this.color3=true;
                this.color1=false;
                this.color2=false;

            },
            turnto(e){
                this.getAsbList(e,"desc","",'')
            },
            lookinfo(item){
                this.$axios.get("/jump/aprodUrl", {
                    params: {
                        productId: item.productId,
                        shareId: Cookies.get('shareId')
                    }
                }).then(res => {
                    window.location.href = res.data
                });
            }
        }
    }
</script>

<style scoped>
    .list-bottom{
        height: 3.2rem;
        width: 100%;
    }
    .colors{
        color: rgb(17, 196, 177);
    }
    .vanticon{
        position: relative;
        top: 2px;
        left: 6px;width: 25px;
    }
    .content{
        width: 100%;
        background-color: #fff;
    }
    .content .title{
        width: 92vw;
        display: flex;
        justify-content: space-between;
        color: #aaa;
        margin: 0 auto;
        font-size: 18px;
        line-height: 62px;
    }
    .content  .text{
        width: 32vw;
        float: left;
        text-align: center;
        font-size: .9rem;
        line-height: 3rem;
    }
    .content .title-box{
        width: 100%;
        height: 3rem;
        border-bottom: 1px solid #eee;
        background: white;
    }
    .content .title div:first-child{
        font-weight: bold;
        font-size: 1.2rem;
        color: #333!important;
    }
    /*列表*/
    .content .list-box{
        margin: 0 auto;
    }
    .content .list-box .list-item{
        width: 92vw;
        display: flex;
        border-bottom: 1px solid #eee;
        margin: 4vw;
        padding-bottom: 20px;
    }
    .list-item2{
        width: 100%;
        height: 60px;
        border-bottom: 1px solid #eee;
        margin-top: 35px;margin-bottom: 5rem;

    }
    .content .list-box .list-item .img-item{
        width: 100px;
        height: 100px;
        border-radius: 4px;
        overflow: hidden;
        flex-shrink:0;
    }
    .content .list-box .list-item .img-item img{
        width: 100%;
        height: 100%;
    }
    .content .list-box .list-item .content-item{
        font-size: 1rem;
        line-height: 1.5rem;
        margin-left: 4vw;
        width: 100%;
    }

    .content .list-box .list-item .content-item .title-item{
        color: #101010;
        font-style: normal;
        font-weight: bold;
        overflow : hidden;
        text-overflow: ellipsis;
        display: -webkit-box;
        -webkit-line-clamp: 2;
        -webkit-box-orient: vertical;
    }
    .content .list-box .list-item .content-item .text-item{
        color: #999;
    }
    .content .list-box .list-item .content-item .money-item{
        color: rgba(2, 150, 136, 1);
        font-size: 1.4rem;
        font-weight: bold;
        line-height: 1.8rem;
        margin-top: 8px;
    }

</style>